import type { AuthUser } from "@/features/auth"
import { paymentService } from "../services/payment-api"

interface FinalizeForUserOptions {
  subscriptionId: string
  /** Falls back to the user's own email when omitted. */
  email?: string
  plan?: string
}

/**
 * Bind a no-user subscription to the signed-in account (`POST /subs/finalize`).
 *
 * Centralizes the two things every caller needs to get right: skip the finalize
 * for the dev-bypass user (no real backend subscription) or a missing id, and
 * identify the user by Apple token when present, else by Firebase uid.
 *
 * Used both post-purchase (`/create-account`, id from the purchase store) and
 * from the emailed activation link (`/activate`, id from the URL) so a user who
 * never finished sign-up can still finalize later.
 */
export async function finalizeSubscriptionForUser(
  user: AuthUser,
  { subscriptionId, email, plan }: FinalizeForUserOptions,
): Promise<void> {
  if (!subscriptionId || user.uid === "dev-user") return

  await paymentService.finalizeSubscription({
    subscriptionId,
    email: email || user.email || "",
    ...(user.appleToken ? { appleToken: user.appleToken } : { firebaseId: user.uid }),
    plan,
  })
}
